import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const e=i("cuba",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L23.9997 4.5L23.9997 20.5L0 20.5L0 4.5Z"
                fill="#002A8F" />
            <path
                d="M2.40039 7.7002L24.0001 7.7002V10.9002L7.20032 10.9002L7.20032 14.1002L24.0001 14.1002V17.3002L2.40039 17.3002L2.40039 7.7002Z"
                fill="white" />
            <path
                d="M10.3919 12.5L0 20.5L0 4.5L10.3919 12.5Z"
                fill="#CB1515" />
            <path
                d="M4.10248 9.83301L2.34427 14.6543L6.9491 11.6677H1.25586L5.86069 14.6543L4.10248 9.83301Z"
                fill="white" />
        </svg>
    `),d=i("cuba_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66553)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L32.105 0.5L32.105 24.5L0 24.5L0 0.5Z"
                    fill="#002A8F" />
                <path
                    d="M3.21094 5.2998L32.1054 5.2998V10.0998L9.63193 10.0998V14.8998L32.1054 14.8998V19.6998L3.21094 19.6998L3.21094 5.2998Z"
                    fill="white" />
                <path
                    d="M13.9015 12.5L0 24.5L0 0.5L13.9015 12.5Z"
                    fill="#CB1515" />
                <path
                    d="M5.48769 8.5L3.13569 15.732L9.29569 11.252L1.67969 11.252L7.83969 15.732L5.48769 8.5Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66553">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{e as Cuba,d as CubaRounded};
